var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompactTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.888,
    height: 9.1927,
    viewBox: "0 0 2.8808 2.4322",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(510.13 -236.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -510.13,
    y: 236.89,
    width: 2.8808,
    height: 2.4322,
    rx: 0.443,
    ry: 0.443,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -509.91,
    y: 237.13,
    width: 1.1915,
    height: 1.1915,
    rx: 0.20156,
    ry: 0.20156,
    fill: "#fff",
    strokeWidth: 1.2719,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -508.45,
    y: 237.42,
    width: 1.044,
    height: 0.25535,
    rx: 0.12768,
    ry: 0.12768,
    fill: "#fff",
    strokeWidth: 0.90441,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -508.45,
    y: 238.03,
    width: 1.044,
    height: 0.25535,
    rx: 0.12768,
    ry: 0.12768,
    fill: "#fff",
    strokeWidth: 0.90441,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -508.45,
    y: 238.63,
    width: 1.044,
    height: 0.25535,
    rx: 0.12768,
    ry: 0.12768,
    fill: "#fff",
    strokeWidth: 0.90441,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-509.74 238.16.62774-.66321",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.079376
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-509.11 237.5.26995.30608",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.079376
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-509.56 237.63c.0636 0 .11513-.0515.11513-.11514 0-.0636-.0516-.11514-.11513-.11514-.0636 0-.11514.0515-.11514.11514 0 .0636.0516.11514.11514.11514z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.079376
  })), /*#__PURE__*/React.createElement("rect", {
    x: -509.8,
    y: 237.24,
    width: 0.96756,
    height: 0.96756,
    rx: 0.10446,
    ry: 0.10446,
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.079376,
    style: {
      paintOrder: "stroke markers fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompactTable);
export default __webpack_public_path__ + "static/media/icon_compact_table.911fccf2d8e00e3b048f637754586cdd.svg";
export { ForwardRef as ReactComponent };